<script lang="ts">
    import KpCollapsibleMenuWrapper from 'shared/ui-widgets/menu-wrapper/KpCollapsibleMenuWrapper.svelte';
    import KpUserInfoCard from '../../../user/KpUserInfoCard.svelte';
    import type {User} from 'typings/portaro.be.types';
    import KpButton from 'shared/ui-widgets/button/KpButton.svelte';
    import {getInjector, getLocalization} from 'core/svelte-context/context';
    import {KpSearchItemUserPresenter} from './kp-search-item-user.presenter';
    import KpUsernameLabel from '../../../user/KpUsernameLabel.svelte';
    import {Kind} from 'shared/constants/portaro.constants';
    import Label from 'shared/components/kp-label/Label.svelte';
    import type {SearchManager} from '../../search-manager/search-manager';

    export let user: User;
    export let refreshSearchManager: SearchManager<User>;

    const localize = getLocalization();
    const presenter = getInjector().getByToken<KpSearchItemUserPresenter>(KpSearchItemUserPresenter.presenterName);
    async function editUser() {
        user = await presenter.editUser(user);
    }

    async function deleteUser() {
        await presenter.deleteUser(user);
        return refreshSearchManager.refreshSearch();
    }
</script>

<template>
    <KpCollapsibleMenuWrapper>
        <div slot="main" class="list-item-user">
            <KpUserInfoCard {user} let:userData>
                <h2 class="unset-style nazevZaznamu">
                    <Label labeled={userData} explicitKind={Kind.KIND_USER} additionalClasses="user-printable-name"/>
                    {#if userData.username}
                        <KpUsernameLabel user={userData}/>
                    {/if}
                </h2>
            </KpUserInfoCard>
        </div>
        <div slot="menu" let:collapsed>
            <li class="collapsible-menu-item">
                <KpButton noWrap isBlock={true} buttonSize="xs" on:click={editUser}>
                    <span class="glyphicon glyphicon-edit" aria-hidden="true"></span>
                    <span class:sr-only={collapsed}>{localize(/* @kp-localization commons.editovat */ 'commons.editovat')}</span>
                </KpButton>
            </li>
            <li class="collapsible-menu-item">
                <KpButton noWrap isBlock={true} buttonSize="xs" on:click={deleteUser}>
                    <span class="glyphicon glyphicon-trash" aria-hidden="true"></span>
                    <span class:sr-only={collapsed}>{localize(/* @kp-localization commons.Smazat */ 'commons.Smazat')}</span>
                </KpButton>
            </li>
        </div>
    </KpCollapsibleMenuWrapper>
</template>